
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.58 1.67a8.387 8.387 0 00-6.483 5.56l3.619 1.23a4.564 4.564 0 013.529-3.026L8.58 1.669zM11.245 18.228a8.387 8.387 0 006.554-5.123l-3.537-1.447a4.564 4.564 0 01-3.567 2.788l.55 3.782z","fill":"#E345FF"}}),_c('path',{attrs:{"d":"M17.795 13.116a8.386 8.386 0 00-9.247-11.44l.679 3.76a4.565 4.565 0 015.032 6.228l3.536 1.452zM2.093 7.241a8.387 8.387 0 009.185 10.982l-.566-3.78a4.565 4.565 0 01-4.999-5.977l-3.62-1.225z","fill":"#5935DD"}})])
          )
        }
      }
    